import { useT } from '@/i18n/useT'
import mysa from '@/assets/clients/mysa.png'
import sons from '@/assets/clients/sons.png'
import arojma from '@/assets/clients/arojma.png'
import dash from '@/assets/clients/Dash.png'
import freshtracks from '@/assets/clients/freshtracks.png'
import pangea from '@/assets/clients/pangea.png'
import baskin from '@/assets/clients/baskin.png'
import upsstore from '@/assets/clients/upsstore.png'
import voyis from '@/assets/clients/voyis.png'
import afghanflame from '@/assets/clients/afghanflame.png'

// `lg` gives visually light marks (thin-line artwork) a size bump
// so they carry the same weight as solid wordmark/icon logos.
// `wide` renders wide wordmarks slightly shorter so their ink
// area matches the rest of the strip instead of dominating it.
const logos: { src: string; alt: string; lg?: boolean; wide?: boolean }[] = [
  { src: freshtracks, alt: 'Fresh Tracks Canada' },
  { src: baskin, alt: 'Baskin Robbins' },
  { src: mysa, alt: 'Mysa' },
  { src: upsstore, alt: 'The UPS Store' },
  { src: pangea, alt: 'Pangea Pod Hotel' },
  { src: sons, alt: 'Sons of Kent' },
  { src: voyis, alt: 'Voyis', wide: true },
  { src: arojma, alt: 'Aroma Espresso Bar' },
  { src: afghanflame, alt: 'Afghan Flame' },
  { src: dash, alt: 'Dash Social' },
]

export default function ClientLogos() {
  const t = useT()
  return (
    <section className="bg-white border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-8 py-12">
        <p className="text-center text-sm font-medium text-ink-mute mb-9">
          {t.home.clients}
        </p>
        <div className="flex items-center justify-between gap-8">
          {logos.map((l) => (
            <img
              key={l.alt}
              src={l.src}
              alt={l.alt}
              className={`${l.wide ? 'h-10 max-w-[180px]' : l.lg ? 'h-[4.25rem] max-w-[130px]' : 'h-14 max-w-[110px]'} w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
